export default {
    URL: function () {
        if (typeof document != "undefined") {
            var link = document.createElement("a");
            link.href = "/";
            let st = link.href;
            st = st.substring(0, st.length - 1);
            return st
        }
        return "/"
    },
    guaranteetypes: [
        { title1: "بدون گارانتی", image: "shield.svg", key: 0, bg: "#B1B5A2" },
        { title1: "گارانتی بازگشت وجه یک", image: "shield.svg", key: 1 },
        { title1: "گارانتی بازگشت وجه دو", image: "shield.svg", key: 2 },
        { title1: "گارانتی مشاوره", image: "shield.svg", key: 3 }
    ],
    journaltypes: [
        {
            name: "car",
            image: "https://cdn.qepal.com/qepal/cat/fa/car.webp"
        },
        {
            name: "financial",
            image: "https://cdn.qepal.com/qepal/cat/fa/financial.webp"
        },
        {
            name: "health",
            image: "https://cdn.qepal.com/qepal/cat/fa/health.webp"
        },
        {
            name: "knowledge",
            image: "https://cdn.qepal.com/qepal/cat/fa/knowledge.webp"
        },
        {
            name: "news",
            image: "https://cdn.qepal.com/qepal/cat/fa/news.webp"
        },
        {
            name: "tutorial",
            image: "https://cdn.qepal.com/qepal/cat/fa/tutorial.webp"
        },
        {
            name: "usersuccess",
            image: "https://cdn.qepal.com/qepal/cat/fa/usersuccess.webp"
        },
        {
            name: "video",
            image: "https://cdn.qepal.com/qepal/cat/fa/video.webp"
        },
        {
            name: "travel",
            image: "https://cdn.qepal.com/qepal/cat/fa/travel.webp"
        },

    ],
    twostepdepexpire: 3600000,
    freezeperday: 15,
    sitefiles: "https://cdn.qepal.com/qepal",
    defaultFont: "Segoe UI, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    address: "https://qepal.com",
    whatsapp: "+989178207012",
    whatsappstr: "+98-917-8207012",
    telegram: "qepalcom",
    telegramusername: "qeadmin",
    telegramstr: "@qepalcom",
    instagram: "qepalcom",
    email: "info@qepal.com",
    phones: ["+982174391640", "+982174391650", "+982174391645", "+982174391655",],
    phonestr: ["+98-21-743916-40", "+98-21-743916-50", "+98-21-743916-45", "+98-21-743916-55"],
    phonestrir: ["۰۲۱-۷۴۳۹۱۶-۴۰", "۰۲۱-۷۴۳۹۱۶-۵۰", "۰۲۱-۷۴۳۹۱۶-۴۵", "۰۲۱-۷۴۳۹۱۶-۵۵"],
    phoneenabled: true,
    linkedin: "",
    instagramstr: "@qenews",
    youtube: "https://www.youtube.com/@TuringResearchTeam",
    twitter: "qenewss",
    twitterstr: "@qenewss",
    skype: "qepalcom",
    aparat: "qepalcom",
    unlinkjournalwallet: { tether: 0.05 },

    meta: {
        "fa": {
            "title": "کیو ای (QE) — زیرساخت فناوری مقاوم برای آینده",
            "description": "کیو ای (QE) راهکار زیرساخت فناوری پیشرفته‌ای ارائه می‌دهد که شما را در برابر تغییرات سریع آینده، مقاوم و سازگار می‌سازد."
        },
        "en": {
            "title": "QE — Future proof infrastructure",
            "description": "QE provides an advanced technology infrastructure solution that makes you resistant and adaptable to the rapid changes of the future."
        },
        "fr": {
            "title": "QE — Infrastructure à l'épreuve du futur",
            "description": "QE fournit une solution d'infrastructure technologique avancée qui vous rend résistant et adaptable aux changements rapides du futur."
        },
        "de": {
            "title": "QE — Zukunftssichere Infrastruktur",
            "description": "QE bietet eine fortschrittliche technologische Infrastrukturlösung, die Sie widerstandsfähig und anpassungsfähig gegenüber den schnellen Veränderungen der Zukunft macht."
        },
        "es": {
            "title": "QE — Infraestructura preparada para el futuro",
            "description": "QE ofrece una solución avanzada de infraestructura tecnológica que le hace resistente y adaptable a los rápidos cambios del futuro."
        },
        "ru": {
            "title": "QE — Инфраструктура, готовая к будущему",
            "description": "QE предлагает передовое решение в области технологической инфраструктуры, которое делает вас устойчивыми и адаптируемыми к быстрым изменениям будущего."
        },
        "tr": {
            "title": "QE — Geleceğe dayanıklı altyapı",
            "description": "QE, sizi geleceğin hızlı değişimlerine karşı dirençli ve uyumlu hale getiren gelişmiş bir teknoloji altyapı çözümü sunar."
        },
        "pt": {
            "title": "QE — Infraestrutura à prova de futuro",
            "description": "A QE oferece uma solução avançada de infraestrutura de tecnologia que o torna resistente e adaptável às rápidas mudanças do futuro."
        },
        "ur": {
            "title": "QE — مستقبل کے تقاضوں پر پورا اترنے والا انفراسٹرکچر",
            "description": "QE جدید ٹیکنالوجی انفراسٹرکچر کا حل فراہم کرتا ہے جو آپ کو مستقبل کی تیز رفتار تبدیلیوں کے خلاف مزاحم اور ہم آہنگ بناتا ہے۔"
        },
        "ar": {
            "title": "QE — بنية تحتية مُهيأة للمستقبل",
            "description": "تقدم QE حلاً متقدماً للبنية التحتية التكنولوجية يجعلك مقاوماً ومتكيفاً مع التغيرات السريعة في المستقبل."
        },
        "ko": {
            "title": "QE — 미래 지향적 인프라",
            "description": "QE는 미래의 빠른 변화에 대응하여 저항력과 적응력을 갖출 수 있도록 하는 고급 기술 인프라 솔루션을 제공합니다."
        },
        "ja": {
            "title": "QE — 将来を見据えたインフラストラクチャ",
            "description": "QEは、将来の急速な変化に対して耐性と適応性を持たせる高度なテクノロジーインフラソリューションを提供します。"
        },
        "zh": {
            "title": "QE — 面向未来的基础设施",
            "description": "QE 提供先进的技术基础设施解决方案，使您能够抵御并适应未来的快速变化。"
        },
        "id": {
            "title": "QE — Infrastruktur yang siap menghadapi masa depan",
            "description": "QE menyediakan solusi infrastruktur teknologi canggih yang membuat Anda tahan dan mudah beradaptasi terhadap perubahan cepat di masa depan."
        }
    },
    workers: {
        mt4: {
            link: "https://qeworker.s3.ir-tbz-sh1.arvanstorage.ir/ME.7z",
            path: "./Worker/MT4",
        }
    },
    softwares: {
        qesuite: {
            name: "QE-suite",
            platforms:
            {
                android:
                {
                    key: "android",
                    minos: "Android 7.0 (API 24)",
                    version: 1.25,
                    image: "https://cdn.qepal.com/qepal/apk.svg",
                },
                windows:
                {
                    key: "windows",
                    minos: "Windows 8.1 (x64)",
                    version: 2.56,
                    image: "https://cdn.qepal.com/qepal/win.png",
                },
                macos:
                {
                    key: "macos",
                    minos: "macOS 10.14",
                    version: 3.66,
                    image: "https://cdn.qepal.com/qepal/macos.webp",
                },
                ios:
                {
                    key: "ios",
                    minos: "iOS 8.0",
                    version: 1.95,
                    image: "https://cdn.qepal.com/qepal/ios.svg",
                },
                ubuntu:
                {
                    key: "ubuntu",
                    minos: "Ubuntu v16.25",
                    version: 6.18,
                    image: "https://cdn.qepal.com/qepal/ubuntu.svg",
                },
            }

        }
    },

    supportdeps: [
        {
            name: "general",
            image: "https://cdn.qepal.com/qepal/supporter.svg"
        },
        {
            name: "sell",
            image: "https://cdn.qepal.com/qepal/supporter.svg"
        }

    ]
}

export type langType = "ar" | "de" | "en" | "es" | "fa" | "fr" | "id" | "ja" | "ko" | "pt" | "ru" | "tr" | "ur" | "zh";